import Enums from 'utils/EnumsManager';
import { SET_MODULES } from './actionType';

const { ObjectTypes } = Enums;
const { Leads, Accounts, Opportunities } = ObjectTypes;

const initailState = {
  [Leads]: [],
  [Accounts]: [],
  [Opportunities]: [],
};

const searchLayout = (state = initailState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_MODULES:
      const { moduleInfo, objectType } = payload;
      return {
        ...state,
        [objectType]: moduleInfo,
      };

    default:
      return state;
  }
};

export default searchLayout;



// WEBPACK FOOTER //
// ./src/views/Setup/SearchLayout/flow/reducer.js